export default "__VITE_ASSET__BpqVI6bl__"